export default __webpack_public_path__ + "static/banner-time-to-renovate-your-bathroom-856934b9015aa2c758c6550c23f8070c.jpg";